export const REGISTER_AUTH_TOKEN = 'REGISTER_AUTH_TOKEN';
export const SHOW_LOCK_SCREEN = 'SHOW_LOCK_SCREEN';
export const HIDE_LOCK_SCREEN = 'HIDE_LOCK_SCREEN';

export const registerAuthenticationToken = data => ({
  type: REGISTER_AUTH_TOKEN,
  data,
});

export const registerAuthToken = data => registerAuthenticationToken(data);

export const showLockScreen = () => ({
  type: SHOW_LOCK_SCREEN,
});

export const hideLockScreen = () => ({
  type: HIDE_LOCK_SCREEN,
});
